import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    main: {
      display: 'flex',
      flexGrow: 1,
      minHeight: `calc(100vh - ${theme.spacing(8)}px)`,
      overflowY: 'auto',
      marginTop: theme.spacing(8),
    },
    appMenuWraper: {
      display: 'flex',
    },
  })
);
